import { isNewRelicEnabled, NEW_RELIC_PLATFORM_SURFACE } from './newRelicConfig';
import { getObservabilityRoutePatterns } from './routePatterns';
import { syncNewRelicRouteContext } from './syncNewRelicRouteContext';

const routePatterns = getObservabilityRoutePatterns();

/** Subscribe to React Router navigations so route context is set during the interaction, not after paint. */
export function attachNewRelicRouteSync(router) {
  if (!isNewRelicEnabled()) return () => {};

  const sync = pathname => {
    const nr = window.newrelic;
    if (!nr) return;
    syncNewRelicRouteContext(nr, pathname, routePatterns, NEW_RELIC_PLATFORM_SURFACE);
  };

  sync(router.state.location.pathname);
  return router.subscribe(state => sync(state.location.pathname));
}
